// AI Generated file
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'escapeRegExp',
    standalone: false,
})
export class EscapeRegExpPipe implements PipeTransform {
    transform (str: string): string {
        str = str || '';
        return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
}
